import { Component, OnInit, ViewChild } from '@angular/core';
import { reports } from '../models/reports';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { currentInventory } from '../models/currentInventory';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ImageCompressService } from 'ng2-image-compress';
import { Options } from "@angular-slider/ngx-slider";

@Component({
  selector: 'app-reportsmanagement',
  templateUrl: './reportsmanagement.component.html',
  styleUrls: ['./reportsmanagement.component.css']
})
export class ReportsmanagementComponent implements OnInit {
  reportsAddObj: reports
  categoriesList: any;
  subCategoriesList: any;
  show: boolean = false;
  reportTypeSelectedValue: any
  showPeriodVsPeriod: boolean = false;
  showRegular: boolean = false;
  fromDate: any;
  toDate: any
  marked: any;
  checkvalue: any;
  sumResult: any;
  showDates: boolean = false;
  dataSource: any;
  dataSourceWeek: any;
  displayedWeekColumns = ['period', 'totalvalution', 'prodcount']
  value: number = 2;
  options: Options = {
    floor: 2,
    ceil: 10
  };
  periodValue: number = 1;
  periodOption: Options;
  periodHighValue: number;

  productsList: any = []
  displayedColumns = ['accountEmailId', 'productName', 'productUniqueNumber', 'productImage', 'description', 'stockQuantity', 'stockUnit', 'purchaseDate', 'expiryDate', 'storageLocation', 'borrowed', 'category', 'subCategory', 'price', 'orderId', 'vendor', 'uploadType', 'status', 'productManuallyAddOrAutoMovedDate', 'addedByUserId']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  productImageId: any;
  myurl: string;
  showPeriod: boolean;
  da: string = "";
  gridsize: any
  showPeriodSlider: boolean = false;
  totalReportsList: any;
  showPeriodVsPeriodResult: boolean = false;
  showSpinner:boolean=false
  constructor(private cs: CucurachaAdminService) {
    this.reportsAddObj = new reports()
    this.myurl = this.cs.endpoint;

  }
  getAllCategories() {
    this.cs.getAllCategory().subscribe((data) => {
      this.categoriesList = data

    });
  };
  updateValue(event) {
    this.gridsize = event.value;
  }
  applyCustomizedFilter() {
    this.reportsAddObj.periodicType;
    if (this.reportTypeSelectedValue == "pvp") {
      this.showPeriodVsPeriod = true
      this.showRegular = false

    } else {
      this.showRegular = true
      this.showPeriodVsPeriod = false

    }

  }
  getSubCategoryByCategoryId(id: any) {
    this.cs.getSubCategoryByCategoryId(id).subscribe((data) => {
      this.subCategoriesList = data


    });



  }
  handleSlider(periodicType) {
    this.showPeriodSlider = true
    if (this.reportsAddObj.periodicType == "Weekly") {
      this.periodHighValue = 52
      this.periodOption = {
        floor: 1,
        ceil: 52
      };
    } else if (this.reportsAddObj.periodicType == "Monthly") {
      this.periodHighValue = 12
      this.periodOption = {
        floor: 1,
        ceil: 12
      };

    } else if (this.reportsAddObj.periodicType == "Quarterly") {
      this.periodHighValue = 4
      this.periodOption = {
        floor: 1,
        ceil: 4
      };
    } else if (this.reportsAddObj.periodicType == "Annually") {
      this.showPeriodSlider = false

    }
  }

  getReports() {

    console.log(this.reportsAddObj)
    this.showSpinner=true;
   
    console.log(this.reportsAddObj)

    if (this.reportsAddObj.reportName == "DemandForecast") {
      this.da=""
      this.showDates = false
      this.showPeriod = false
      if (this.reportTypeSelectedValue == "pvp") {
        this.reportsAddObj.span = this.value
        this.reportsAddObj.fromDate = this.periodValue
        this.reportsAddObj.toDate = this.periodHighValue
        console.log(this.reportsAddObj)
        this.cs.getAllDemandForcastPeriodVsPeriod(this.reportsAddObj).subscribe((data) => {
          console.log(data)
         
          this.sumResult = data.sumResult

          this.totalReportsList = data.result
          console.log(this.totalReportsList.length)
          this.da += "<table class='table table-bordered' style='width:50%'><tr style='background-color: #353556'>"
          this.da += "<th>"+data.periodicType+"</th>"

          for (let z = 0; z < this.totalReportsList.length; z++) {
            console.log(this.totalReportsList[z].Year)

            this.da += "<th>" + this.totalReportsList[z].Year + "</th>"
          }
          this.da += "<tr>";
          for (let x = 0; x < this.totalReportsList[0].periodicalList.length; x++) {

            this.da += "<td>" + this.totalReportsList[0].periodicalList[x].number + "</td>"
          for (let y = 0; y < this.totalReportsList.length; y++) {

            this.da += "<td>" + this.totalReportsList[y].periodicalList[x].TotalAmount + "</td>"
          }
            this.da += "</tr>";


          }

          this.da += "</table>"
          console.log(this.da)
          this.showPeriodVsPeriodResult = true
          this.showSpinner=false;

        })

      }
      else if (this.reportTypeSelectedValue == "fd" && this.reportsAddObj.periodicType != "Weekly" && this.reportsAddObj.periodicType != "Monthly") {
        this.reportsAddObj.periodicType = "dates"

        this.cs.getAllDemandForcast(this.reportsAddObj).subscribe((data) => {
          console.log(data)
          this.showDates = true
          this.showPeriod = false
          this.sumResult = data.sumResult
          for (var i = 0; i < data.result.length; i++) {
            this.productsList.push(data.result[i].productdetails)


            if (i == (data.result.length) - 1) {
              this.showSpinner=false;

              this.dataSource = new MatTableDataSource(this.productsList)
              this.dataSource.sort = this.sort
              this.dataSource.paginator = this.paginator
              console.log(data)
            }
          }
        })
      } else {
        this.cs.getAllDemandForcast(this.reportsAddObj).subscribe((data) => {
          this.sumResult = data.sumResult
         
          

              this.sumResult = data.sumResult
              this.showSpinner=false;
              this.showDates = false
              this.showPeriod = true
              this.showSpinner=false;

              this.dataSourceWeek = new MatTableDataSource(data.result)
              this.dataSourceWeek.sort = this.sort
              this.dataSourceWeek.paginator = this.paginator
    
           
        })
      }

    } else if (this.reportsAddObj.reportName == "HistoricalConsumption") {
      this.da=""
      this.showDates = false
      this.showPeriod = false
      if (this.reportTypeSelectedValue == "pvp") {
        this.reportsAddObj.span = this.value
        this.reportsAddObj.fromDate = this.periodValue
        this.reportsAddObj.toDate = this.periodHighValue
        console.log(this.reportsAddObj)
        this.cs.getAllHistoricalConsumptionPeriodVsPeriod(this.reportsAddObj).subscribe((data) => {
          console.log(data)
          this.showDates = false
          this.showPeriod = false
          this.totalReportsList = data.result
          console.log(this.totalReportsList.length)
          this.da += "<table class='table table-bordered' style='width:50%'><tr style='background-color: #353556'>"
          this.da += "<th>"+data.periodicType+"</th>"

          for (let z = 0; z < this.totalReportsList.length; z++) {
            console.log(this.totalReportsList[z].Year)

            this.da += "<th>" + this.totalReportsList[z].Year + "</th>"
          }
          this.da += "<tr>";
          for (let x = 0; x < this.totalReportsList[0].periodicalList.length; x++) {

            this.da += "<td>" + this.totalReportsList[0].periodicalList[x].number + "</td>"
          for (let y = 0; y < this.totalReportsList.length; y++) {

            this.da += "<td>" + this.totalReportsList[y].periodicalList[x].TotalAmount + "</td>"
          }
            this.da += "</tr>";


          }

          this.da += "</table>"
          console.log(this.da)
          this.showPeriodVsPeriodResult = true
          this.showSpinner=false;

        })

      }
      else if (this.reportTypeSelectedValue == "fd" && this.reportsAddObj.periodicType != "Weekly" && this.reportsAddObj.periodicType != "Monthly") {
        this.reportsAddObj.periodicType = "dates"
        this.productsList=[]

        this.cs.getAllHistoricalConsumption(this.reportsAddObj).subscribe((data) => {
          console.log(data)
          this.showDates = true
          this.showPeriod = false
          this.sumResult = data.sumResult
          for (var i = 0; i < data.result.length; i++) {
            console.log(data.result[i].ordersList)
            for (var j = 0; j <data.result[i].ordersList.length; j++) {

            this.productsList.push(data.result[i].ordersList[j].productdetails)
            }

            if (i == (data.result.length) - 1) {
              this.showSpinner=false;

              this.dataSource = new MatTableDataSource(this.productsList)
              this.dataSource.sort = this.sort
              this.dataSource.paginator = this.paginator
              console.log(data)
            }
          }
        })
      } else {
        this.productsList=[]

        this.cs.getAllHistoricalConsumption(this.reportsAddObj).subscribe((data) => {
          this.sumResult = data.sumResult
          console.log(data)
                   this.sumResult = data.sumResult
          this.showDates = false
          this.showPeriod = true
          this.showSpinner=false;

          this.dataSourceWeek = new MatTableDataSource(data.result)
          this.dataSourceWeek.sort = this.sort
          this.dataSourceWeek.paginator = this.paginator

          
        })
      }
    } else if (this.reportsAddObj.reportName == "HistoricalWastage") {

      this.da=""
      this.showDates = false
      this.showPeriod = false
      if (this.reportTypeSelectedValue == "pvp") {
        this.reportsAddObj.span = this.value
        this.reportsAddObj.fromDate = this.periodValue
        this.reportsAddObj.toDate = this.periodHighValue
        console.log(this.reportsAddObj)
        this.cs.getAllHistoricalWastagePeriodVsPeriod(this.reportsAddObj).subscribe((data) => {
          console.log(data)
          this.sumResult = data.sumResult
          this.showDates = false
          this.showPeriod = false
          this.totalReportsList = data.result
          console.log(this.totalReportsList.length)
          this.da += "<table class='table table-bordered' style='width:50%'><tr style='background-color: #353556!important;color:white'>"
          this.da += "<th>"+data.periodicType+"</th>"

          for (let z = 0; z < this.totalReportsList.length; z++) {
            console.log(this.totalReportsList[z].Year)

            this.da += "<th>" + this.totalReportsList[z].Year + "</th>"
          }
          this.da += "<tr>";
          for (let x = 0; x < this.totalReportsList[0].periodicalList.length; x++) {

            this.da += "<td>" + this.totalReportsList[0].periodicalList[x].number + "</td>"
          for (let y = 0; y < this.totalReportsList.length; y++) {

            this.da += "<td>" + this.totalReportsList[y].periodicalList[x].TotalAmount + "</td>"
          }
            this.da += "</tr>";


          }

          this.da += "</table>"
          console.log(this.da)
          this.showPeriodVsPeriodResult = true
          this.showSpinner=false;

        })

      }
      else if (this.reportTypeSelectedValue == "fd" && this.reportsAddObj.periodicType != "Weekly" && this.reportsAddObj.periodicType != "Monthly") {
        this.reportsAddObj.periodicType = "dates"
        this.productsList=[]
        this.cs.getAllHistoricalWastage(this.reportsAddObj).subscribe((data) => {
          this.showDates = true
          this.showPeriod = false
          this.sumResult = data.sumResult
          for (var i = 0; i < data.result.length; i++) {
            console.log(data.result[i].ordersList)
            for (var j = 0; j <data.result[i].ordersList.length; j++) {

            this.productsList.push(data.result[i].ordersList[j].productdetails)
            }


            if (i == (data.result.length) - 1) {
              this.showSpinner=false;

              this.dataSource = new MatTableDataSource(this.productsList)
              this.dataSource.sort = this.sort
              this.dataSource.paginator = this.paginator
              console.log(data)
            }
          }
        })
      } else {
        this.productsList=[]

        this.cs.getAllHistoricalWastage(this.reportsAddObj).subscribe((data) => {
          this.sumResult = data.sumResult
         
          this.showDates = false
          this.showPeriod = true
          this.showSpinner=false;
          this.dataSourceWeek = new MatTableDataSource(data.result)
          this.dataSourceWeek.sort = this.sort
          this.dataSourceWeek.paginator = this.paginator

        })
      }
    }

  }
  viewImages(id: any) {
    this.productImageId = id
  }
  toggleVisibility(e) {
    this.marked = e.target.checked;
    this.checkvalue = this.marked;
    this.show = true
  }

  ngOnInit(): void {
    this.getAllCategories()
  }

}
